import React from "react";
import { logEvent } from "./eventLogger.js";

const MODULE_NAME = "53_date_range_selector";

const ranges = [
    { label: "Last 7", value: "7" },
    { label: "Last 30", value: "30" },
    { label: "Last 60", value: "60" },
    { label: "Last 90", value: "90" },
    { label: "Last 180", value: "180" },

];

export default function DateRangeSelector({ value, onDateChange, hidden = false, userId }) {
    // Hide component if hidden prop is true
    if (hidden) return null;

    return (
        <div style={{ display: "flex", gap: 12, alignItems: "center", margin: "12px 0" }}>
            {ranges.map(range => {
                const subcomponentLabel = `Date Range: ${range.label}`;
                return (
                    <a
                        key={range.value}
                        href="#"
                        onClick={e => {
                            e.preventDefault();
                            if (onDateChange) onDateChange(range.value);

                            // Retrieve currentScreen from sessionStorage
                            const currentScreen = sessionStorage.getItem("currentScreen") || "unknown";

                            // Log the event
                            logEvent({
                                event_type: "link_click",
                                user_id: userId,
                                module_name: MODULE_NAME,
                                subcomponent: MODULE_NAME,
                                screen: currentScreen,
                                metadata: {
                                    button_link_value: range.label
                                }
                            });
                        }}
                        style={{
                            padding: "6px 12px",
                            textDecoration: value === range.value ? "none" : "none",
                            fontWeight: value === range.value ? 700 : 400,
                            color: value === range.value ? "#007bff" : "#007bff",
                            background: "transparent",
                            border: "none",
                            borderBottom: value === range.value ? "2px solid #007bff" : "1px solid transparent",
                            transition: "border-bottom 0.2s, font-weight 0.2s",
                            cursor: "pointer"
                        }}
                    >
                        {range.label}
                    </a>
                );
            })}
        </div>
    );
}

